import { ApiClientFactory } from "common/middleware/api.client-factory";
import { Logger } from "common/middleware/logger";

export const markNotificationAsRead = async (notificationId: string) => {
  Logger.debug("Marking notification as read", notificationId);
  const client = await ApiClientFactory.getUserNotificationsClient();
  await client.markAsRead(notificationId);
}
